import { getModelWiseParamsHistoricalHeatmap } from "../../services/util/backdatedParams"
import "./style.css"
import { useSelector } from "react-redux"

interface HeatMapItemProps {
    heatMapData: any
    handleHeatMapClick: any
    type: any
    identifier: any
    index: any,
    boxShadow: any,
    setboxShadow: any
}


// Returns rgb code
function greenColorShadeRgbByPercentage(percent: number) {
    let redAndBlueCode = Math.round(158 - ((158 * Math.abs(percent)) / 100));
    return redAndBlueCode + ", 255, " + redAndBlueCode; // Dark green 0, 255, 0
}

// Returns rgb code
function redColorShadeRgbByPercentage(percent: number) {
    let greenAndBlueCode = Math.round(158 - ((158 * Math.abs(percent)) / 100));
    return "255, " + greenAndBlueCode + ", " + greenAndBlueCode; // Dark green 0, 255, 0
}

export const HeatMapItem: React.FC<HeatMapItemProps> = ({ boxShadow, setboxShadow, heatMapData, handleHeatMapClick, type, identifier, index }) => {

    function getBackgroundColor() {
        if (parseFloat(heatMapData.percentage) < 0) {
            return redColorShadeRgbByPercentage(parseFloat(heatMapData.percentage));
        } else {
            return greenColorShadeRgbByPercentage(parseFloat(heatMapData.percentage));
        }
    }
    const theme: any = useSelector((state: any) => {
        return state.theme.isTheme;
    })
    const getHetMapColour = () => {
        if (heatMapData?.pl_percentage >= 0) {
            return 'rgb(79 255 58 / 79%)'
        }
        else if (heatMapData?.pl_percentage < 0) {
            return '#ff450080'
        }
    }
    const getBorder = () => {
        if (theme === 'light') {
            return "4px solid rgb(118, 159, 205)"
        }
        else if (theme === 'dark') {
            return "4px solid rgb(207, 134, 44)"
        }
        else if (theme === 'b&w') {
            return "4px solid rgba(96, 95, 95, 0.86)"
            
        }
    }

    
    return <>{heatMapData?.pl_percentage != null &&
        <div className={`heat-map-item ${boxShadow === index ? "heatmapBoxshadaow" : ""}`} style={{
            backgroundColor: "rgb(" + getBackgroundColor() + ")",
            border: `${boxShadow === index ? getBorder() : ''}`}} onClick={() => {
            handleHeatMapClick(heatMapData)
            setboxShadow(heatMapData.s_version)
        }} >
            <div className={`${heatMapData?.s_version === "all" ? '' : "heatmap_content_inside "}`} >
                {heatMapData?.s_version === "all" ? 
                <div className="heatmaphover" style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                    ALL
                </div> 
                :<div className="heatmaphover" style={{ fontWeight: "bold", fontSize: "0.9rem" }} data-hover={identifier != undefined && (identifier.substring(1, 3) === 'ES'||identifier.slice(0,3)==='QEB')? identifier : identifier}>
                    {identifier != undefined && (identifier.substring(1, 3) === 'ES'||identifier.slice(0,3)==='QEB')? heatMapData?.asset : getModelWiseParamsHistoricalHeatmap(identifier)}
                </div>}
                {heatMapData?.s_version === "all" || ['equityMultiday','equityN50BANK'].includes(type) ? 
                <div style={{ pointerEvents: "none" }}>{heatMapData?.s_version === 'all' ? '' : '₹'} {((heatMapData?.sum)?.toFixed(2))}</div> :
                    <div className="heatmaphover" data-hover={`${heatMapData?.s_version === "all" ? '' : Number(heatMapData?.sum).toFixed(2)} pts`}>
                        ₹ {(heatMapData?.pl_in_rs)?.toFixed(2)}
                    </div>}
                {heatMapData?.s_version === "all" ? <div style={{ height: "1vw", pointerEvents: "none" }}> </div> : 
                <span className="heatMap_percentageDiv" style={{ background: getHetMapColour() }}>{(heatMapData?.pl_percentage)?.toFixed(2)}%</span>}
            </div>
        </div>}</>
}

